export default {
	profile: [],
	user: null,
	inactiveUserTimeThreshold:  1000 * 3600, // 1 hours
	userActivityThrottlerTime: 1000 * 60 // 1 minute
}
